import { render } from "./Categories.vue?vue&type=template&id=dcd6e7b6&scoped=true&ts=true"
import script from "./Categories.vue?vue&type=script&lang=ts"
export * from "./Categories.vue?vue&type=script&lang=ts"

import "./Categories.vue?vue&type=style&index=0&id=dcd6e7b6&lang=scss&scoped=true"

import exportComponent from "E:\\vue_test\\form-gpt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcd6e7b6"]])

export default __exports__